export const getAccessor = (column: any) =>
    typeof column?.accessor === "string" ? column.accessor : column?.id;

export const getLabel = (column: any) =>
    typeof column?.Header === "function" ? getAccessor(column) : column?.Header;

export const toConfig = (columns: any[]) => columns.map((column: any) => ({
    ...column,
    name: getAccessor(column),
    label: getLabel(column),
    enableSorting: !column?.disableSortBy,
}));

const byAccessor = (saved: any[] = []) => saved.reduce((total: any, item: any) => {
    total[item.accessor] = item;
    return total;
}, {});

export const buildColumnsValue = (columns: any[], hiddenColumns: string[] = [], saved: any[] = [], { canSort = true } = {}) => {
    const savedMap = byAccessor(saved);
    return columns
        .filter((column: any) => !["selection", "actions"].includes(column.id))
        .map((column: any) => {
            const accessor = getAccessor(column);
            return {
                accessor,
                hide: hiddenColumns.includes(accessor),
                hideCompletely: false,
                ...(canSort && { hideSort: false }),
                ...savedMap[accessor],
            };
        });
};

export const buildFiltersValue = (filters: any[], saved: any[] = []) => {
    const savedMap = byAccessor(saved);
    return filters.map((filter: any) => {
        const accessor = getAccessor(filter);
        return { accessor, hide: false, ...savedMap[accessor] };
    });
};
